import { Header } from "./components/Header";
import { HeroLaunch } from "./components/HeroLaunch";
import { AppsCube } from "./components/AppsCube";
import { WaiterScene } from "./components/WaiterScene";
import { FeaturesAccordion } from "./components/FeaturesAccordion";
import { CaseAlem } from "./components/CaseAlem";
import { ShaderBand } from "./components/ShaderBand";
import { PricingOrbit } from "./components/PricingOrbit";
import { TariffBuilder } from "./components/TariffBuilder";
import { FAQ } from "./components/FAQ";
import { LeadForm } from "./components/LeadForm";
import { ContactStrip } from "./components/ContactStrip";
import { Footer } from "./components/Footer";
import { Rail } from "./components/Rail";
import { CursorGlow } from "./components/CursorGlow";
import { lazy, Suspense } from "react";

const LegalPage = lazy(() =>
  import("./components/LegalPage").then((m) => ({ default: m.LegalPage })),
);

export function App() {
  // Лендинг — без роутера (Vite base="/landing/", Vercel ловит под-пути).
  // Правовые страницы разруливаем по pathname: /landing/privacy, /landing/terms.
  const path = typeof window !== "undefined" ? window.location.pathname : "/";
  const legalKind = path.endsWith("/privacy")
    ? "privacy"
    : path.endsWith("/terms")
      ? "terms"
      : null;

  if (legalKind) {
    return (
      <Suspense fallback={<div className="min-h-dvh" style={{ background: "var(--bg)" }} />}>
        <LegalPage kind={legalKind} />
      </Suspense>
    );
  }

  return (
    <div className="min-h-dvh" style={{ background: "var(--bg)" }}>
      <Header />
      <Rail />
      <CursorGlow />
      <main>
        <HeroLaunch />
        <AppsCube />
        <WaiterScene />
        <FeaturesAccordion />
        <CaseAlem />
        <ShaderBand />
        <PricingOrbit />
        <TariffBuilder />
        <FAQ />
        <LeadForm />
        <ContactStrip />
      </main>
      <Footer />
    </div>
  );
}
